export const trimText = (
  text?: string | null,
  maxLength: number = 30,
  ellipsis: string = "..."
) => {
  if (!text) return "";
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength - ellipsis.length) + ellipsis;
};
